import i18n from 'services/base/i18n';

export default {
  apply:              () => i18n.pgettext('Pages|List Issues|Filter Issue', 'APPLY'),
  searchLabel:        () => i18n.pgettext('Pages|List Issues|Filter Issue', 'SEARCH'),
  searchPlaceholder:  () => i18n.pgettext('Pages|List Issues|Filter Issue', 'Text search query'),
  startDateLabel:     () => i18n.pgettext('Pages|List Issues|Filter Issue', 'START DATE'),
  endDateLabel:       () => i18n.pgettext('Pages|List Issues|Filter Issue', 'END DATE'),
  seenLabel:          () => i18n.pgettext('Pages|List Issues|Filter Issue', 'SEEN'),
  seenPlaceholder:    () => i18n.pgettext('Pages|List Issues|Filter Issue', 'Seen, New'),
  severityLabel:      () => i18n.pgettext('Pages|List Issues|Filter Issue', 'SEVERITY'),
  affectedLabel:      () => i18n.pgettext('Pages|List Issues|Filter Issue', 'AFFECTED'),
  incidentsLabel:     () => i18n.pgettext('Pages|List Issues|Filter Issue', 'INCIDENTS'),
  kindsLabel:         () => i18n.pgettext('Pages|List Issues|Filter Issue', 'TYPES'),
  kindsPlaceholder:   () => i18n.pgettext('Pages|List Issues|Filter Issue', 'Add Type'),
  devicesLabel:       () => i18n.pgettext('Pages|List Issues|Filter Issue', 'DEVICES'),
  devicesPlaceholder: () => i18n.pgettext('Pages|List Issues|Filter Issue', 'Add Device'),
  invalidSeen:        () => i18n.pgettext('Pages|List Issues|Filter Issue', 'At least one item is required'),

  rangeMinLabel: () => i18n.pgettext('Pages|List Issues|Filter Issue', 'MINIMUM'),
  rangeMaxLabel: () => i18n.pgettext('Pages|List Issues|Filter Issue', 'MAXIMUM'),

  errorMinLessThanZero: () => i18n.pgettext('Pages|List Issues|Filter Issue', 'Minimum must be greater than or equal to zero'),
  errorMaxLessThanZero: () => i18n.pgettext('Pages|List Issues|Filter Issue', 'Maximum must be greater than or equal to zero'),
  errorMaxLessThanMin:  () => i18n.pgettext('Pages|List Issues|Filter Issue', 'Maximum must be greater than or equal to minimum'),
};
